import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import PickupLocationForm from 'common/components/address/PickupLocationForm';
import { FormError } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { listPickupLocations } from 'redux/inventoryLocations/actions';

import CustomerDisplay from './components/CustomerDisplay';
import { validateForLoggedInCustomerPickup } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const clubSignup = {
      orderDeliveryMethod: 'Pickup',
      pickupInventoryLocationId: data.inventoryLocationId,
      giftMessage: null,
      shippingInstructions: null
    };
    props.updateClubSignup(clubSignup);
  };

  handleShip = (e) => {
    e.preventDefault();
    const { onShip } = this.props;
    onShip();
  };

  render() {
    const { customer, handleSubmit, settings, formValues } = this.props;
    const { form, inventoryLocation } = this.props;
    if (!inventoryLocation.data || !formValues) {
      return null;
    }
    let clubSelection = 'club selection';
    if (isPreSale()) {
      clubSelection = 'pre-sale selection';
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <CustomerDisplay customer={customer.data} />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Pickup address</h3>
          <a
            className="c7-checkout__content__title__ship"
            onClick={this.handleShip}
          >
            I prefer to have my club shipment shipped
          </a>
        </div>
        <PickupLocationForm
          formValues={formValues}
          inventoryLocation={inventoryLocation}
        />
        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to billing information
          </button>
          <a href={`${getClubList(settings)}`}>Return to {clubSelection}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email,
    inventoryLocationId: values.inventoryLocationId
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  const errors = validateForLoggedInCustomerPickup(data, ownProps.settings);
  return errors;
};

const getFirstInventoryLocation = (inventoryLocation) => {
  if (!inventoryLocation || !inventoryLocation.data) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);

  return inventoryLocationIdArray[0];
};

const mapStateToProps = (state) => {
  const clubSignup = state.clubSignup.data;
  const initialValues = {};
  if (clubSignup) {
    initialValues.email = clubSignup.email;
    initialValues.inventoryLocationId = clubSignup.pickupInventoryLocationId;
  }
  if (!initialValues.inventoryLocationId) {
    initialValues.inventoryLocationId = getFirstInventoryLocation(
      state.inventoryLocation
    );
  }
  return {
    initialValues,
    settings: state.setting,
    customer: state.customer,
    clubSignup: state.clubSignup,
    inventoryLocation: state.inventoryLocation,
    formValues:
      state.form.customerLoggedInPickup &&
      state.form.customerLoggedInPickup.values
  };
};

Customer = reduxForm({
  form: 'customerLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Customer);

export default connect(mapStateToProps, {
  updateClubSignup,
  listPickupLocations
})(Customer);
